import { render, staticRenderFns } from "./ProductSalesSummary.vue?vue&type=template&id=563deaab&scoped=true&"
import script from "./ProductSalesSummary.vue?vue&type=script&lang=js&"
export * from "./ProductSalesSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesSummary.vue?vue&type=style&index=0&id=563deaab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563deaab",
  null
  
)

export default component.exports